__webpack_require__.p = "https://www.typhi.net/";